import React from "react";
import Switch from "react-toggle-switch";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import "./style.scss";

const ToggleSwitch = ({
  on = false,
  label = "",
  containerClassName = "",
  ...props
}) => (
  <div className={classnames("cnb-switch", containerClassName, { on })}>
    {label && (
      <label onClick={props.onClick}>
        <FormattedMessage id={label} />
      </label>
    )}
    <Switch on={on} {...props} />
  </div>
);

export default ToggleSwitch;
